import TurndownService from 'turndown';

/**
 * Creates a memoized page content getter for the given iframe ref.
 * Runs turndown only when the iframe URL has changed since the last call.
 *
 * @param {React.RefObject} iframeRef
 * @returns {function(): {pageTitle: *, currentUrl: *, pageContent: null|undefined|*}}
 */
export function createPageContextGetter(iframeRef) {
  const turndownService = new TurndownService();
  let cachedUrl = null;
  let cachedMarkdown = null;

  return function getPageContext() {
    const contentDocument = iframeRef?.current?.contentDocument;
    const contentWindow = iframeRef?.current?.contentWindow;
    const currentUrl = contentWindow?.location?.href;

    let pageContent;

    if (currentUrl && currentUrl === cachedUrl) {
      pageContent = cachedMarkdown;
    } else {
      const html =
        contentDocument?.getElementById?.('main-content')?.innerHTML ||
        contentDocument?.querySelector?.('.venom-app')?.innerHTML;

      if (html) {
        pageContent = turndownService.turndown(html);
        cachedUrl = currentUrl;
        cachedMarkdown = pageContent;
      }
    }

    return {
      pageTitle: contentDocument?.title,
      currentUrl,
      pageContent,
    };
  };
}
